export const formatComposerName = (name: string, locale: string) => {
    if (locale === "hu") {
        return name
            .replace("Modest Mussorgsky", "Modeszt Muszorgszkij")
            .replace("Mussorgsky", "Muszorgszkij")
            .replace("Pyotr Ilyich Tchaikovsky", "Pjotr Iljics Csajkovszkij")
            .replace("Tchaikovsky", "Csajkovszkij")
            .replace("Igor Stravinsky", "Igor Sztravinszkij")
            .replace("Stravinsky", "Sztravinszkij")
    }
    return name;
}
